import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import './service-monitoring-page.scss';
import {
  getPaginationOpts,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import PageHeader from '../../../components/base/PageHeader/PageHeader';
import { loadMonitorList } from '../actions';
import { getMonitorData } from '../reducer';
import { getSystemData } from '../../System/reducer';
import Loader from '../../../components/base/Loader/Loader';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import { dateOrDateTimeFormatter } from '../../../utils/formatters';
import Pagination from '../../../components/base/Pagination/Pagination';

const monitorStatusFormatter = isOnline => (
  <div className="monitoring-status-cell">
    <div className={classNames('monitoring-status-badge', { online: isOnline, offline: !isOnline })}>
      {isOnline ? 'Доступен' : 'Недоступен'}
    </div>
  </div>
);

export default function ServiceMonitoringPage() {
  const dispatch = useDispatch();
  const { monitorList, monitorListMeta, loadingMonitorList } = useSelector(getMonitorData);
  const { updatePeriod } = useSelector(getSystemData);

  const loadData = opts => {
    const paginationOpts = getPaginationOpts(monitorListMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: {},
    };

    return dispatch(loadMonitorList(requestData)).catch(responseLogWithNotification);
  };

  const [setPeriod, destroy] = useUpdatePeriod(loadData, updatePeriod);

  useEffect(() => {
    setPeriod(updatePeriod);
    return destroy;
  }, [updatePeriod]);

  const columns = [
    {
      dataField: 'name',
      text: 'Модуль',
      disableSort: true,
      dataClassName: 'align-middle',
    },
    {
      dataField: 'is_online',
      text: 'Статус',
      disableSort: true,
      dataClassName: 'align-middle',
      formatter: monitorStatusFormatter,
    },
    {
      dataField: 'last_ping_at',
      text: 'Проверено',
      disableSort: true,
      dataClassName: 'align-middle',
      formatter: date => dateOrDateTimeFormatter(date),
    },
  ];

  return (
    <div className="service-monitoring-page">
      <div className="sm-container">
        <div className="sm-inputs-box">
          <PageHeader header="Мониторинг модулей">
            <div className="header-loader"><Loader loading={loadingMonitorList} /></div>
          </PageHeader>
        </div>
        <div className="sm-table g-0">
          <div className="frame">
            <div className="sticky-table-wrapper custom-scroll-theme">
              <CustomizedGrid
                className="sm-grid"
                data={monitorList}
                columns={columns}
                name="sm-list"
              />
            </div>
          </div>
          <Pagination meta={monitorListMeta} list={monitorList} handleChangeMeta={loadData} />
        </div>
      </div>
    </div>
  );
}
